import './spinner.css';

export default function Spinner() {
  return (
    <div class="spinner-border spinner" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  );
}
